import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'pages',
  children: {
    page: {
      path: ':pageId',
    },
  },
} as const satisfies Location
